var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    {
      staticClass: "search-component",
      attrs: { "grid-list-md": "", fluid: "", "px-2": "", "py-1": "" },
    },
    [
      _c(
        "v-layout",
        { attrs: { wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "" } },
            [
              _c(
                "panel",
                {
                  staticClass: "query-panel d-flex fill-height",
                  attrs: { "fill-height": "" },
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      _vm.$vuetify.breakpoint.smAndDown
                        ? [
                            _vm._v(
                              "\n                Input multimer\n            "
                            ),
                          ]
                        : [
                            _vm._v(
                              "\n                Input protein multimer structure (PDB/CIF)\n            "
                            ),
                          ],
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "template",
                    { slot: "toolbar-extra" },
                    [
                      _c("api-dialog", {
                        attrs: {
                          disabled: _vm.searchDisabled,
                          email: _vm.email,
                          mode: _vm.mode,
                          database: _vm.database,
                          taxfilter: _vm.taxFilter ? _vm.taxFilter.value : "",
                        },
                      }),
                      _vm._v(" "),
                      _vm.query.length > 0
                        ? _c(
                            "v-icon",
                            {
                              staticStyle: { "margin-right": "16px" },
                              attrs: { title: "Clear" },
                              on: {
                                click: function ($event) {
                                  _vm.query = ""
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$MDI.Delete))]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { "open-delay": "300", top: "" },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function ({ on }) {
                                return [
                                  _c("v-icon", _vm._g({}, on), [
                                    _vm._v(_vm._s(_vm.$MDI.HelpCircleOutline)),
                                  ]),
                                ]
                              },
                            },
                          ]),
                        },
                        [
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.$STRINGS.QUERIES_HELP)),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "template",
                    { slot: "content" },
                    [
                      _c("query-textarea", {
                        attrs: { loading: _vm.accessionLoading },
                        model: {
                          value: _vm.query,
                          callback: function ($$v) {
                            _vm.query = $$v
                          },
                          expression: "query",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "actions input-buttons-panel" },
                        [
                          _c(
                            "div",
                            { staticClass: "input-buttons-left" },
                            [
                              _c("load-acession-button", {
                                attrs: {
                                  "preload-source": _vm.preloadSource,
                                  "preload-accession": _vm.preloadAccession,
                                },
                                on: {
                                  select: function ($event) {
                                    _vm.query = $event
                                  },
                                  loading: function ($event) {
                                    _vm.accessionLoading = $event
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("file-button", {
                                attrs: {
                                  id: "file",
                                  label: _vm.$STRINGS.UPLOAD_LABEL,
                                },
                                on: { upload: _vm.upload },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs12: "" } },
            [
              _c(
                "panel",
                {
                  attrs: {
                    collapsible: "",
                    collapsed: "",
                    "render-collapsed": "",
                  },
                },
                [
                  _c(
                    "template",
                    { slot: "header" },
                    [
                      !_vm.$vuetify.breakpoint.smAndDown
                        ? [_vm._v("\n                Databases\n            ")]
                        : [_vm._v("\n                DBs\n            ")],
                      _vm._v("\n            & search settings\n        "),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { attrs: { slot: "content" }, slot: "content" },
                    [
                      _c("databases", {
                        attrs: {
                          selected: _vm.database,
                          "all-databases": _vm.databases,
                          hideEmail: _vm.hideEmail,
                          "interface-only": true,
                        },
                        on: {
                          "update:selected": function ($event) {
                            _vm.database = $event
                          },
                          "update:all-databases": function ($event) {
                            _vm.databases = $event
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "v-radio-group",
                        {
                          model: {
                            value: _vm.mode,
                            callback: function ($$v) {
                              _vm.mode = $$v
                            },
                            expression: "mode",
                          },
                        },
                        [
                          _c(
                            "v-tooltip",
                            {
                              attrs: { "open-delay": "300", top: "" },
                              scopedSlots: _vm._u([
                                {
                                  key: "activator",
                                  fn: function ({ on }) {
                                    return [
                                      _c(
                                        "label",
                                        _vm._g({}, on),
                                        [
                                          _vm._v("Mode "),
                                          _c(
                                            "v-icon",
                                            _vm._g(
                                              {
                                                staticStyle: {
                                                  "margin-top": "-3px",
                                                },
                                                attrs: {
                                                  color: "#FFFFFFB3",
                                                  small: "",
                                                },
                                              },
                                              on
                                            ),
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$MDI.HelpCircleOutline
                                                )
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            },
                            [
                              _vm._v(" "),
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.$STRINGS.MODE_HELP),
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.$STRINGS.MODE_COUNT - 0, function (i) {
                            return _c("v-radio", {
                              key: i,
                              attrs: {
                                "hide-details": "",
                                value:
                                  "interface-" + _vm.$STRINGS["MODE_KEY_" + i],
                                label: _vm.$STRINGS["MODE_TITLE_" + i],
                              },
                            })
                          }),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("TaxonomyAutocomplete", {
                        model: {
                          value: _vm.taxFilter,
                          callback: function ($$v) {
                            _vm.taxFilter = $$v
                          },
                          expression: "taxFilter",
                        },
                      }),
                      _vm._v(" "),
                      !_vm.$ELECTRON && !_vm.hideEmail
                        ? _c(
                            "v-tooltip",
                            {
                              attrs: { "open-delay": "300", top: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on }) {
                                      return [
                                        _c(
                                          "v-text-field",
                                          _vm._g(
                                            {
                                              attrs: {
                                                label:
                                                  "Notification Email (Optional)",
                                                placeholder: "you@example.org",
                                              },
                                              model: {
                                                value: _vm.email,
                                                callback: function ($$v) {
                                                  _vm.email = $$v
                                                },
                                                expression: "email",
                                              },
                                            },
                                            on
                                          )
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                968467921
                              ),
                            },
                            [
                              _vm._v(" "),
                              _c("span", [
                                _vm._v("Send an email when the job is done."),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            [
              _c(
                "panel",
                [
                  _c("template", { slot: "content" }, [
                    _c(
                      "div",
                      {
                        staticClass: "actions",
                        style: !_vm.$vuetify.breakpoint.xsOnly
                          ? "display:flex; align-items: center;"
                          : null,
                      },
                      [
                        _c(
                          "v-item-group",
                          { staticClass: "v-btn-toggle" },
                          [
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  color: "primary",
                                  block: false,
                                  "x-large": "",
                                  disabled: _vm.searchDisabled,
                                },
                                on: { click: _vm.search },
                              },
                              [
                                _c("v-icon", [
                                  _vm._v(_vm._s(_vm.$MDI.Magnify)),
                                ]),
                                _vm._v(" Search"),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            !_vm.isMultimer && _vm.query != ""
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      color: "secondary",
                                      block: false,
                                      "x-large": "",
                                    },
                                    on: { click: _vm.goToMonomer },
                                  },
                                  [
                                    _c("v-icon", [
                                      _vm._v(_vm._s(_vm.$MDI.Monomer)),
                                    ]),
                                    _vm._v(" Go to Monomer"),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            style: !_vm.$vuetify.breakpoint.xsOnly
                              ? "margin-left: 1em;"
                              : "margin-top: 1em;",
                          },
                          [
                            _c("span", [_c("strong", [_vm._v("Summary")])]),
                            _c("br"),
                            _vm._v("\n                Search "),
                            _vm.taxFilter
                              ? [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.taxFilter.text)),
                                  ]),
                                  _vm._v(" in\n                "),
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.database.length == _vm.databases.length
                              ? [
                                  _c("strong", [_vm._v("all available")]),
                                  _vm._v(" databases\n                "),
                                ]
                              : [
                                  _c("strong", [
                                    _vm._v(_vm._s(_vm.database.length)),
                                  ]),
                                  _vm._v(" "),
                                  _vm.database.length == 1
                                    ? [
                                        _vm._v(
                                          "\n                        database\n                    "
                                        ),
                                      ]
                                    : [
                                        _vm._v(
                                          "\n                        databases\n                    "
                                        ),
                                      ],
                                  _vm._v(
                                    "\n                    (" +
                                      _vm._s(
                                        _vm.databases
                                          .filter((db) =>
                                            _vm.database.includes(db.path)
                                          )
                                          .map((db) => db.name)
                                          .sort()
                                          .join(", ")
                                      ) +
                                      ")\n                "
                                  ),
                                ],
                            _vm._v(
                              " with " + _vm._s(_vm.$STRINGS.APP_NAME) + " in "
                            ),
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.modes[_vm.mode.replace("interface-", "")]
                                )
                              ),
                            ]),
                            _vm._v(" mode.\n                "),
                            _vm.errorMessage != ""
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "v-alert v-alert--outlined warning--text mt-2",
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.errorMessage)),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("reference", {
        attrs: { reference: _vm.$STRINGS.CITATION_INTERFACE },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }